import { DiscoLogo } from "./DiscoLogo";

export default function Login({ onLogin, error }) {
  return (
    <div className="min-h-screen flex flex-col bg-black">
      {/* Top bar */}
      <header className="h-16 flex items-center px-6 border-b border-[#282828]">
        <div className="flex items-center gap-2 text-white">
          <DiscoLogo size={34} />
          <span className="font-extrabold text-lg tracking-tight">Glimpse</span>
        </div>
      </header>

      <main className="flex-1 flex items-center justify-center px-6">
        <div className="w-full max-w-md bg-[#121212] rounded-xl p-8 md:p-10 text-center">
          <div className="mx-auto mb-6 flex justify-center">
            <DiscoLogo size={84} />
          </div>
          <h1 className="font-extrabold text-3xl md:text-4xl text-white tracking-tight">
            Connecte-toi à Glimpse
          </h1>
          <p className="mt-3 text-[#B3B3B3] text-sm">
            Playlists Spotify automatiques par mood et durée.<br/>
            Choisis ton humeur, on compose, tu écoutes.
          </p>

          <button
            data-testid="login-spotify-button"
            onClick={onLogin}
            className="mt-8 w-full rounded-full bg-[#FF2E93] hover:bg-[#FF52A3] text-black font-bold py-3.5 px-6 flex items-center justify-center gap-2 transition-transform hover:scale-[1.02] active:scale-[0.98]"
          >
            <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
              <path d="M12 0a12 12 0 1 0 0 24 12 12 0 0 0 0-24zm5.5 17.3a.75.75 0 0 1-1 .25c-2.8-1.7-6.3-2.1-10.5-1.1a.75.75 0 1 1-.3-1.5c4.6-1 8.5-.6 11.6 1.3.3.2.4.7.2 1.1zm1.5-3.3a.95.95 0 0 1-1.3.3c-3.2-2-8-2.6-11.7-1.4a.95.95 0 1 1-.5-1.8c4.3-1.3 9.6-.7 13.3 1.6.4.3.6.9.2 1.3zm.1-3.4C15.2 8 8.9 7.8 5.3 8.9a1.15 1.15 0 1 1-.7-2.2c4.2-1.3 11.1-1 15.2 1.4.6.3.8 1 .4 1.6-.3.5-1 .7-1.6.4z"/>
            </svg>
            Continuer avec Spotify
          </button>

          {error && (
            <div className="mt-5 text-left rounded-md border border-rose-700 bg-rose-900/40 px-4 py-3 text-rose-100 text-sm">
              {error}
            </div>
          )}

          <p className="mt-6 text-xs text-[#6a6a6a]">
            En continuant, tu autorises Glimpse à lire tes playlists et à créer des playlists sur ton compte.
          </p>
        </div>
      </main>

      <footer className="h-14 flex items-center justify-center text-xs text-[#6a6a6a] border-t border-[#282828]">
        Fait avec ♥ · Non affilié à Spotify
      </footer>
    </div>
  );
}
